

document.addEventListener("DOMContentLoaded", function()
        {
            var $animation_elements = $('.animation');
            var $lazy_elements = $('img');
            var $window = $(window);
            function check_if_in_view()
            {
                var window_height = $window.height();
                var window_top_position = $window.scrollTop();
                var window_bottom_position = (window_top_position + window_height);
                $.each($animation_elements, function()
                {
                    var $element = $(this);
                    var element_height = $element.outerHeight();
                    var element_top_position = $element.offset().top;
                    var element_bottom_position = (element_top_position + element_height);
                    //check to see if this current container is within viewport
                    if ((element_bottom_position >= window_top_position) && (element_top_position <= window_bottom_position))
                    {
                        $element.addClass('in-view');
                        counter();
                    }
                    else
                    {
                        $element.removeClass('in-view');
                    }
                });
                $.each($lazy_elements, function()
                {
                    var $lazy_element = $(this);
                    var lazy_element_height = $lazy_element.outerHeight();
                    var lazy_element_top_position = $lazy_element.offset().top;
                    var lazy_element_bottom_position = (lazy_element_top_position + lazy_element_height);
                    //check to see if this current container is within viewport
                    if ((lazy_element_bottom_position >= window_top_position) && (lazy_element_top_position <= window_bottom_position))
                    {
                        if($lazy_element.attr('data-src'))
                        {
                            $lazy_element.attr("src",$lazy_element.attr('data-src'));
                        }
                    }
                });
            }
            $window.on('scroll resize', check_if_in_view);
            $window.trigger('scroll');
        });
            function counter()
            {
                $('.count.animation').each(function()
                {
                    var $this = $(this);
                    if($this.hasClass('in-view'))
                    {
                        jQuery({Counter: 0}).animate({
                            Counter: $this.attr('data-stop') }, {
                            duration: 3000,
                            easing: 'swing',
                            step: function (now)
                            {
                                $this.text(Math.ceil(now));
                            }
                        });
                        $this.removeClass('animation');
                    }
                });
                if(! $('.count').hasClass('in-view'))
                {
                    $('.count').addClass('animation');
                }
            }
